<template>
  <div id="app">
    <router-view></router-view>
    <!-- 注册云企业 -->
    <CloudAuthPopup />
    <!-- 工单下单 -->
    <WorkOrderPlacePopup />
    <!-- 登录弹窗 -->
    <LoginPopup />
  </div>
</template>

<script>
import CloudAuthPopup from '@/components/Popup/CloudEnterpriseAuth.vue';
import WorkOrderPlacePopup from '@/components/Popup/WorkOrderPlace.vue';
import LoginPopup from '@/components/LoginPopup/index.vue';
export default {
  name: 'App',
  components: {
    CloudAuthPopup,
    WorkOrderPlacePopup,
    LoginPopup
  }
};
</script>

<style lang="less">
</style>
